export default "__VITE_ASSET__b090d328__"